<template>
  <EDialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="dialogVisible"
    :popup-width="'560px'"
    :show-btn="showBtn"
    :show-close-btn="showCloseBtn"
    @resetPopupData="cancelHandle"
    @submitPopupData="sureHandle"
  >
    <!-- ： -->
    <el-form ref="form" :rules="rules" :model="form" label-suffix="：" label-width="130px">
      <el-form-item label="供应商名称" prop="companyName">
        <el-input
          v-if="dialogTitle !== '查看'"
          v-model.trim="form.companyName"
          maxlength="50"
          show-word-limit
          placeholder="请输入供应商名称"
        ></el-input>
        <span v-else>{{ form.companyName }}</span>
      </el-form-item>
      <el-form-item label="EQE编码" prop="evaluationCode">
        <el-input
          v-if="dialogTitle !== '查看'"
          v-model.trim="form.evaluationCode"
          maxlength="20"
          show-word-limit
          placeholder="请输入EQE编码"
        ></el-input>
        <span v-else>{{ form.evaluationCode }}</span>
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-if="dialogTitle !== '查看'"
          v-model.trim="form.productName"
          maxlength="60"
          show-word-limit
          placeholder="请输入产品名称"
        ></el-input>
        <span v-else>{{ form.productName }}</span>
      </el-form-item>
      <el-form-item label="证书编号" prop="certificateNo">
        <el-input
          v-if="dialogTitle !== '查看'"
          v-model.trim="form.certificateNo"
          maxlength="50"
          show-word-limit
          placeholder="请输入证书编号"
        ></el-input>
        <span v-else>{{ form.certificateNo }}</span>
      </el-form-item>
      <el-form-item label="报告到期日" prop="deadline">
        <el-date-picker
          v-if="dialogTitle !== '查看'"
          v-model="form.deadline"
          style="width: 100%"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <span v-else>{{ form.deadline }}</span>
      </el-form-item>
      <el-form-item label="评价等级" prop="scoreLevel">
        <el-select
          v-if="dialogTitle !== '查看'"
          v-model.trim="form.scoreLevel"
          style="width: 100%"
          maxlength="20"
          show-word-limit
          placeholder="请选择评价等级"
        >
          <el-option v-for="item in scoreLevels" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span v-else>{{ form.scoreLevel }}</span>
      </el-form-item>
      <el-form-item label="综合得分" prop="score">
        <el-input
          v-if="dialogTitle !== '查看'"
          v-model.trim="form.score"
          maxlength="20"
          show-word-limit
          placeholder="请输入综合得分"
        ></el-input>
        <span v-else>{{ form.score }}</span>
      </el-form-item>
      <el-form-item label="验证网站" prop="checkUrl">
        <el-input
          v-if="dialogTitle !== '查看'"
          v-model.trim="form.checkUrl"
          maxlength="20"
          show-word-limit
          placeholder="请输入验证网站(非必填)"
        ></el-input>
        <span v-else>{{ form.checkUrl }}</span>
      </el-form-item>
      <el-form-item label="报告附件" prop="checkFile">
        <template v-if="dialogTitle !== '查看'">
          <eui-upload
            ref="euiUpload"
            class="video-upload"
            key-name="auditorCertificate"
            :file-list="form.filePathAl"
            :action="videoFileUpload"
            :headers="headers"
            :limit-file-size="20"
            :limit="1"
            show-file-list
            text="选择文件"
            accept=".jpg,.jpeg,.png,.pdf"
            @handleSuccess="fileSuccess"
          ></eui-upload>
          <div class="file-tips">
            <p>附件上传提示:</p>
            <p>1.若附件为多页，请上传PDF格式文件:</p>
            <p>2.文件大小限制: 20MB:</p>
            <p>3.允许文件类型: JPG，JPEG.PNG.PDF:</p>
            <p>4.支持图片尺寸最大2000*2000像素，最小600*600像素</p>
          </div>
        </template>
        <template v-else>
          <span v-for="(item, index) in form.filePathAl" :key="index">{{ item.name }}</span>
        </template>
      </el-form-item>
    </el-form>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import { epecToken } from '@/modules/projectA/utils/globalData';
import Api from '@/modules/projectA/api/ESorganization/index';

export default {
  components: {
    EDialog,
  },
  props: {
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogVisible: Boolean,
    id: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      showBtn: true,
      showCloseBtn: false,
      form: {
        filePathAl: [],
        companyName: '',
        evaluationCode: '',
        productName: '',
        certificateNo: '',
        deadline: '',
        scoreLevel: '',
        score: '',
        checkUrl: '',
        filePath: '',
        fileName: '',
      },
      rules: {
        companyName: [
          {
            required: true,
            message: '请输入供应商名称',
            blur: 'trigger',
          },
        ],
        evaluationCode: [
          {
            required: true,
            message: '请输入EQE编码',
            blur: 'trigger',
          },
        ],
        productName: [
          {
            required: true,
            message: '请输入产品名称',
            blur: 'trigger',
          },
        ],
        certificateNo: [
          {
            required: true,
            message: '请输入证书编号',
            blur: 'trigger',
          },
        ],
        deadline: [
          {
            required: true,
            message: '请选择报告到期日',
            blur: 'trigger',
          },
        ],
        scoreLevel: [
          {
            required: true,
            message: '请选择评价等级',
            blur: 'trigger',
          },
        ],
        score: [
          {
            required: true,
            message: '请输入score',
            blur: 'trigger',
          },
        ],
        /* checkUrl: [
          {
            required: true,
            message: '请输入供应商名称',
            blur: 'trigger',
          },
        ], */
        checkFile: [{ required: true, validator: this.fileMustUpload, trigger: 'change' }],
      },
      headers: epecToken,
      videoFileUpload: Api.fileUploadForProductEvaluationResult,
      scoreLevels: [
        { id: 'AAA', name: 'AAA' },
        { id: 'AA', name: 'AA' },
        { id: 'A', name: 'A' },
        { id: 'BBB', name: 'BBB' },
        { id: 'BB', name: 'BB' },
        { id: 'B', name: 'B' },
        { id: 'CCC', name: 'CCC' },
        { id: 'CC', name: 'CC' },
        { id: 'C', name: 'C' },
        { id: '不合格', name: '不合格' },
      ],
    };
  },
  computed: {},
  watch: {
    dialogTitle: {
      handler(newValue) {
        if (newValue === '查看') {
          this.showBtn = false;
          this.showCloseBtn = true;
          this.rules = {};
          this.getQueryByIdEvaluation(this.id);
        }
        if (newValue === '修改') {
          this.getQueryByIdEvaluation(this.id);
        }
      },
      immediate: true,
    },
    'form.filePathAl': {
      handler(newVal) {
        if (newVal.length > 0) {
          // 取消验证
          this.$refs.form.validateField('checkFile'); // 走rules里面的checkFile规则
        }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    async getQueryByIdEvaluation(id) {
      const res = await Api.queryByIdEvaluation({ id });
      if (res.code === '200') {
        this.form.filePathAl = [{ name: res.data.fileName, url: res.data.filePath }];
        this.form = { ...this.form, ...res.data };
      }
    },
    fileMustUpload(rule, value, callback) {
      if (this.form.filePathAl.length === 0) {
        callback('请上传附件');
      } else {
        callback();
      }
    },
    cancelHandle() {
      this.$emit('update:dialogVisible', false);
    },
    async addEvaluation() {
      console.log(this.form);
      const form = JSON.parse(JSON.stringify(this.form));
      const [first] = form.filePathAl;
      console.log(first, 'first');
      form.filePath = first.url;
      form.fileName = first.name;
      delete form.filePathAl;
      const res = await Api.addEvaluation(form);
      if (res.code === '200') {
        this.$message.success('新增成功');
        this.$emit('refresh');
        this.$emit('update:dialogVisible', false);
      }
    },
    async modifyEvaluation() {
      console.log(this.form);
      const form = JSON.parse(JSON.stringify(this.form));
      const [first] = form.filePathAl;
      console.log(first, 'first');
      form.filePath = first.url;
      form.fileName = first.name;
      delete form.filePathAl;
      const res = await Api.modifyEvaluation(form);
      if (res.code === '200') {
        this.$message.success('修改成功');
        this.$emit('refresh');
        this.$emit('update:dialogVisible', false);
      }
    },
    sureHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.dialogTitle === '新增') {
            this.addEvaluation();
          }
          if (this.dialogTitle === '修改') {
            this.modifyEvaluation();
          }
        }
      });
    },
    // 操作人附件上传
    fileSuccess(obj) {
      try {
        if (obj.code === '200') {
          const filePathAl = this.form.filePathAl.map((item) => {
            console.log(item);
            item.url = obj?.response?.data?.url || item.url;
            item.name = obj?.response?.data?.name || item.name;
            return item;
          });
          console.log(filePathAl);
          this.form.filePathAl = filePathAl;

          this.$message.success('附件上传成功');
        } else {
          this.form.filePathAl = [];
          this.$message.error(obj.message);
        }
      } catch (err) {
        this.$message.error('附件上传失败');
        this.form.filePathAl = [];
      }
      console.log();
    },
  },
};
</script>
<style lang="scss" scoped>
.file-tips {
  margin-top: 10px;
  p {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #333;
  }
}
</style>
